// extracted by mini-css-extract-plugin
export var messageSideLeft = "_kn-1";
export var messageSideRight = "_kn-2";
export var orderLookupBubbleContainer = "_kn-0";
export var submitButton = "_kn-3";